<template>
  <div>
    <div>
      <header-component
        v-if="hData.length > 0"
        :img="hData[0].image_path"
        :title="getLocalized(hData[0], 'title')"
        :detailed="getLocalized(hData[0], 'description')"
      ></header-component>
    </div>

    <div>
      <serviceDisplayComponentVue></serviceDisplayComponentVue>
    </div>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent.vue";
import serviceDisplayComponentVue from "../components/ServiceComponentFinal/servicesComponent.vue";
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
export default {
  components: {
    serviceDisplayComponentVue,
    HeaderComponent,
  },
  data() {
    return {
      hData: [],
      api: process.env.VUE_APP_API_KEY,
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  mounted() {
    this.fetchHeader();
  },
  methods: {
    async fetchHeader() {
      try {
        const response = await axios.get(this.api + "/api/sliders");
        this.hData = response.data.items;
        this.hData = this.hData.filter((item) => item.id === 2);
        this.hData = this.hData.map((item) => ({
          ...item,
          image_path: `${this.api}${item.image_path}`,
        }));
      } catch (e) {
        console.error(e.message);
      }
    },
  },
};
</script>
